import { Grid } from "@mui/material";
import NavigationDrawer from "../../components/drawer/NavigationDrawer";
import { NAVIGATION_DRAWER_TYPE_HR, NAVIGATION_DRAWER_TYPE_ICO } from "../../components/drawer/NavigationDrawer/NavigationDrawer";
import DefaultPageWrapper from "../../components/wrapper/DefaultPageWrapper";
import IcoReportsTabs from "../../components/tabs/IcoReportsTabs/IcoReportsTabs";
import useHRService from "../../services/hrService";
import usePaginationWithSearchParams from "../../hooks/usePaginationWithSearchParams";
import useLocalData from "../../hooks/useLocalData";
import { useCallback, useMemo, useState } from "react";
import { SURVEY_TABLE_FIELDS_CONFIG, SURVEY_TABLE_NAME } from "./PageTablesConfig";
import UniversalToolBarWithDialogs from "../../components/bar/UniversalToolBarWithDialogs";
import FilterTable from "../../components/table/FilterTable";
import { useTranslation } from "react-i18next";
import LoaderWrapper from "../../components/wrapper/LoaderWrapper";
import TableService from "../../services/tableService";
import { useEmptyArrayMemo } from "../../hooks/useEmptyArrayMemo";
import { hrSurveyExportListUrl } from "../../helpers/apiUrls";
import { useAsync } from "../../hooks/useAsync";
import useDialogWithId from "../../hooks/useDialogWithId";
import HrSurveyDialog from "../../components/dialog/HrSurveyDialog/HrSurveyDialog";
import { useSnackbarAlert } from "../../context/snackbarAlert";
import { HR_SURVEY_SEND_ACTION } from "../../helpers/constants";
import { useCrudFn } from "../../hooks/useCrudFn";



export default function HrSurveyRegistryPage(props) {
  const { t } = useTranslation();

  const { pageName } = props;
  const snackbarAlert = useSnackbarAlert();

  const TABLE_CONFIGS = [
    { name: SURVEY_TABLE_NAME, config: SURVEY_TABLE_FIELDS_CONFIG },
  ];

  const [hiddenColumnsForTables, setHiddenColumnsForTables] = useState([]);
  const [columnsOrdersForTables, setColumnsOrdersForTables] = useState([]);
  const [isCopyMode, setIsCopyMode] = useState(false)

  const [openSurveyDialog, surveyId, onOpenSurveyDialog, onCloseSurveyDialog] =
    useDialogWithId();

  const { emptyArrayMemo } = useEmptyArrayMemo()

  const {
    getSurveysList,
    updateSurvey,
    getSurveyFilteringData
  } = useHRService();

  const filteringData = useAsync(getSurveyFilteringData)

  const onClickOpenSurvey = useCallback((e, surveyId) => {
    e.stopPropagation()
    onOpenSurveyDialog(surveyId)
    setIsCopyMode(false)
  }, [])
  const onClickCopySurvey = useCallback((e, surveyId) => {
    e.stopPropagation()
    onOpenSurveyDialog(surveyId)
    setIsCopyMode(true)
  }, [])

    const onClickSendSurvey = useCallback((e, surveyId, allowSend) => {
    e.stopPropagation()
    setIsCopyMode(false)
    if (allowSend){
    return surveyCrudFn.onUpdateObject(surveyId, { id: surveyId, action: HR_SURVEY_SEND_ACTION }, dataRefetch)
    }else{
      
         return snackbarAlert.openWarningSnackbarAlert(
        t(`snackbar_alert.not_all_necessary_data_are_fulfilled`)
      );
    }
  }, [])

  const {
    page: surveyPage,
    pageSize: surveyPageSize,
    handleChangePageWithSearchParams: handleChangeSurveyPage,
    handleChangePageSizeWithSearchParams: handleChangeSurveyPageSize,
    resetPageNumber: resetSurveyPageNumber,
    searchParams: surveySearchParams,
    onClearSearchParams: onClear
  } = usePaginationWithSearchParams();

  const {
    data: surveyData,
    dataCount,
    dataLoading,
    dataRefetch,
    tableData: surveyTableData
  } = useLocalData(getSurveysList, surveySearchParams, true, undefined, SURVEY_TABLE_FIELDS_CONFIG, hiddenColumnsForTables?.[SURVEY_TABLE_NAME], columnsOrdersForTables?.[SURVEY_TABLE_NAME], onClickSendSurvey, onClickOpenSurvey, onClickCopySurvey);

  const surveyExportHeaders = useMemo(() => {
    return TableService.getTableExportHeaders(
      SURVEY_TABLE_FIELDS_CONFIG,
      hiddenColumnsForTables?.[SURVEY_TABLE_NAME],
      columnsOrdersForTables?.[SURVEY_TABLE_NAME]
    );
  }, [
    SURVEY_TABLE_FIELDS_CONFIG,
    hiddenColumnsForTables,
    columnsOrdersForTables
  ]);

    const surveyCrudFn = useCrudFn(null, updateSurvey, null, "survey");
  
  



  const handleCloseDialog = useCallback((areDataChanged) =>{
    if (areDataChanged){
      dataRefetch()
    }
    onCloseSurveyDialog()
    setIsCopyMode(false)
  })


  return (
    <NavigationDrawer
      drawerType={NAVIGATION_DRAWER_TYPE_HR}
      pageName={pageName}
    >
      <DefaultPageWrapper titleKey={pageName}>
        <Grid
          container
          item
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          rowSpacing={1}
        >
          <Grid item xs={12} marginY={1}>
            <UniversalToolBarWithDialogs
              pageName={pageName}
              tableConfig={TABLE_CONFIGS}
              filteringData={filteringData ?? {}}
              refreshTable={dataRefetch}
              resetPageNumber={resetSurveyPageNumber}
              hiddenColumnsForTables={hiddenColumnsForTables}
              setHiddenColumnsForTables={setHiddenColumnsForTables}
              columnsOrdersForTables={columnsOrdersForTables}
              setColumnsOrdersForTables={setColumnsOrdersForTables}
              showMassActionButton={false}
              showOpenCloseFilterButton={false}
              showCleanfiltersButton={true}
              showMyFiltersButton={true}
              showSearchButton={true}
              cleanFiltersFn={onClear}
              showCreateButton={true}
              onClickCreateItem={(e) => onOpenSurveyDialog()}
              itemType={"survey"}
              mdGridButton={2.75}
            />
          </Grid>
          <Grid item xs={12}>
            <LoaderWrapper showLoader={surveyData === undefined || filteringData.loading || surveyCrudFn.isUpdatingLoading}>
              <FilterTable
                data={surveyTableData}
                showCheckbox={false}
                showCleanFilterIcon={true}
                countRecords={dataCount}
                page={surveyPage}
                onPageChange={handleChangeSurveyPage}
                rowsPerPage={surveyPageSize}
                onRowsPerPageChange={handleChangeSurveyPageSize}
                resetPageNumber={resetSurveyPageNumber}
                filteringData={filteringData}
                style={{ maxHeight: "vh" }}
                tableConfig={SURVEY_TABLE_FIELDS_CONFIG}
                showContextMenu={false}
                headersConfig={TableService.getHeadersConfigForCollapsibleTable(
                  SURVEY_TABLE_FIELDS_CONFIG,
                  filteringData || emptyArrayMemo,
                  hiddenColumnsForTables ? hiddenColumnsForTables[SURVEY_TABLE_NAME] : emptyArrayMemo,
                  columnsOrdersForTables ? columnsOrdersForTables[SURVEY_TABLE_NAME] : emptyArrayMemo,
                )}
                showExportToFileButton={true}
                exportToFileUrl={hrSurveyExportListUrl}
                exportToFileSearchParams={surveySearchParams}
                exportToFileHeaders={surveyExportHeaders}
                exportToFileFileName={`${t(
                  "page.surey_registry_page.surveys_registry"
                ).replace(" ", "_")}.xlsx`} 
                isLoading={dataLoading}
              />
            </LoaderWrapper>
          </Grid>
        </Grid>
        {openSurveyDialog &&
        <HrSurveyDialog
        open={openSurveyDialog}
        onClose={handleCloseDialog}
        surveyId={surveyId}
        isCopyMode={isCopyMode}
        />

        }
      </DefaultPageWrapper>
    </NavigationDrawer>
  );
}
